<template>
  <b-modal id="loaddashwin" size="xl" hide-footer :dialog-class="'ld-dialog'" body-class="ld-body" @show="onShow" @hidden="drawer = null">
    <template #modal-header="{ close }">
      <h5 class="modal-title ld-title">Выполнение нагрузки</h5>
      <button type="button" class="close" aria-label="Закрыть" @click="close()">&times;</button>
    </template>

    <!-- строка меню -->
    <div class="ld-menu" role="toolbar" aria-label="Действия">
      <button type="button" class="ld-mi" :disabled="busy" title="Заново загрузить нагрузку из ISS" @click="$emit('reload')">
        <b-icon icon="arrow-repeat" aria-hidden="true"></b-icon><span>Обновить<span class="ld-long"> из ISS</span></span>
      </button>
      <span class="ld-seg" role="group" aria-label="Вид">
        <button type="button" class="ld-mi" :aria-pressed="String(mode === 'cards')" title="Карточки предметов" @click="setMode('cards')">
          <b-icon icon="grid" aria-hidden="true"></b-icon><span class="ld-long">Карточки</span>
        </button>
        <button type="button" class="ld-mi" :aria-pressed="String(mode === 'table')" title="Сводная таблица" @click="setMode('table')">
          <b-icon icon="table" aria-hidden="true"></b-icon><span class="ld-long">Таблица</span>
        </button>
      </span>
      <span class="ld-sep" aria-hidden="true"></span>
      <button type="button" class="ld-mi ld-mi-primary" :disabled="busy || !works.length" title="Сверить журнал ISS с расписанием по всем работам" @click="runAudit(null)">
        <b-icon icon="search" aria-hidden="true"></b-icon><span>Аудит<span class="ld-long"> проведённых занятий</span></span>
      </button>
      <button type="button" class="ld-mi" :disabled="busy" title="Внести внеаудиторную нагрузку (подготовка, методическая работа, контроль СРС…) целиком одной строкой" @click="openNonAudit">
        <b-icon icon="check2-square" aria-hidden="true"></b-icon><span>Внеаудиторная<span class="ld-long"> нагрузка</span></span>
      </button>
      <span class="ld-meta">{{ works.length }} работ в нагрузке</span>
    </div>

    <!-- итоги -->
    <div class="ld-kpis">
      <div class="ld-kpi">
        <b>{{ total.done }} / {{ total.plan }}</b><span>часов выполнено</span>
        <div class="ld-track"><i :style="{ width: pct(total.done, total.plan) + '%' }"></i><em :style="{ left: pace * 100 + '%' }"></em></div>
      </div>
      <div class="ld-kpi"><b>{{ Math.round(pace * 100) }}%</b><span>семестра прошло</span></div>
      <div class="ld-kpi" :class="lagging ? 'ld-bad' : 'ld-good'"><b>{{ lagging }} из {{ subjects.length }}</b><span>предметов отстают</span></div>
      <div class="ld-kpi" :class="notIssTotal ? 'ld-bad' : 'ld-good'"><b>{{ notIssTotal }}</b><span>занятий не в ISS</span></div>
    </div>

    <div class="ld-main">
      <p v-if="!works.length" class="ld-empty">Нагрузка ISS не загружена. Нажмите «Обновить из ISS».</p>

      <!-- карточки -->
      <div v-else-if="mode === 'cards'" class="ld-cards">
        <button v-for="(s, k) in subjects" :key="s.name" type="button" class="ld-card" @click="openSubject(k)">
          <span class="ld-card-top">
            <span class="ld-card-title"><b>{{ s.name }}</b><small>{{ s.groups.join(', ') }}</small></span>
            <svg class="ld-ring" viewBox="0 0 52 52" aria-hidden="true">
              <circle cx="26" cy="26" r="22" fill="none" stroke="var(--bg-muted)" stroke-width="6" />
              <circle cx="26" cy="26" r="22" fill="none" :stroke="statusColor(s.status)" stroke-width="6"
                :stroke-dasharray="ring(s.pct)" transform="rotate(-90 26 26)" />
              <text x="26" y="30" text-anchor="middle" font-size="12" font-weight="700" fill="currentColor">{{ Math.round(s.pct * 100) }}%</text>
            </svg>
          </span>
          <span v-for="w in s.works" :key="w.id" class="ld-wrow">
            <span class="ld-lbl" :class="'ld-t' + catIdx(w.cat)" :title="w.groups">{{ CAT[w.cat] || 'Др.' }}<small v-if="s.multi[w.cat]">{{ shortGroups(w.groups) }}</small></span>
            <span class="ld-bar"><i :class="'ld-c' + catIdx(w.cat)" :style="{ width: pct(w.done, w.plan) + '%' }"></i><em :style="{ left: pace * 100 + '%' }"></em></span>
            <span class="ld-num">{{ w.done }}/{{ w.plan }} ч</span>
          </span>
          <span class="ld-card-foot">
            <span>проведено {{ s.lessons.length }}</span>
            <span v-if="s.notIss" class="ld-chip ld-chip-bad">не в ISS: {{ s.notIss }}</span>
            <span v-else class="ld-chip ld-chip-ok">всё в ISS</span>
            <span class="ld-chip" :class="'ld-chip-' + s.status">{{ STATUS[s.status] }}</span>
          </span>
        </button>
      </div>

      <!-- сводная таблица -->
      <div v-else class="ld-tablewrap">
        <table class="ld-table">
          <thead>
            <tr>
              <th class="ld-nm" scope="col">Предмет</th>
              <th v-for="c in shownCats" :key="c" scope="col" class="ld-hide-m"><span :class="'ld-t' + catIdx(c)">●</span> {{ CATF[c] }}</th>
              <th scope="col">Итого</th>
              <th scope="col" class="ld-hide-m">Статус</th>
              <th scope="col">Не в ISS</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(s, k) in subjects">
              <tr :key="s.name" class="ld-row" :class="{ 'ld-open': expanded === k }" tabindex="0"
                @click="expanded = expanded === k ? null : k" @keydown.enter="expanded = expanded === k ? null : k">
                <th class="ld-nm" scope="row">{{ s.name }}<small>{{ s.groups.join(', ') }}</small></th>
                <td v-for="c in shownCats" :key="c" class="ld-hide-m">
                  <template v-if="s.byCat[c]">
                    <span class="ld-bar"><i :class="'ld-c' + catIdx(c)" :style="{ width: pct(s.byCat[c].done, s.byCat[c].plan) + '%' }"></i><em :style="{ left: pace * 100 + '%' }"></em></span>
                    <small class="ld-num">{{ s.byCat[c].done }} / {{ s.byCat[c].plan }} ч</small>
                  </template>
                  <span v-else class="ld-dim">—</span>
                </td>
                <td class="ld-tot"><b>{{ Math.round(s.pct * 100) }}%</b><small>{{ s.done }}/{{ s.plan }} ч</small></td>
                <td class="ld-hide-m"><span class="ld-chip" :class="'ld-chip-' + s.status">{{ STATUS[s.status] }}</span></td>
                <td><span class="ld-chip" :class="s.notIss ? 'ld-chip-bad' : 'ld-chip-ok'">{{ s.notIss }}</span></td>
              </tr>
              <tr v-if="expanded === k" :key="s.name + '-det'" class="ld-det">
                <td :colspan="shownCats.length + 4">
                  <span v-if="!s.lessons.length" class="ld-dim">Проведённых занятий по расписанию нет.</span>
                  <span v-for="l in s.lessonsDesc" :key="l.day + l.time" class="ld-pill" :class="{ 'ld-pill-no': !l.inIss }" :title="l.type + (l.inIss ? '' : ' — не в ISS')">
                    {{ shortDate(l.day) }} <span :class="'ld-t' + catIdx(l.cat)">{{ CAT[l.cat] }}</span>
                  </span>
                  <button type="button" class="ld-mi ld-mi-primary ld-more" @click.stop="openSubject(k)">Подробнее <b-icon icon="chevron-right" aria-hidden="true"></b-icon></button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <p v-if="outside" class="ld-note">Ещё {{ outside }} проведённых занятий по расписанию не относятся ни к одной работе нагрузки ISS (совещания, ГПМ и т.п.) — аудит покажет их отдельно.</p>

    </div>

    <!-- окно предмета: поверх окна дашборда, вне прокручиваемого списка
         (внутри списка панель уезжала вместе с прокруткой) -->
    <aside class="ld-drawer" :class="{ 'ld-drawer-on': drawerSubj }" :aria-hidden="String(!drawerSubj)" aria-label="Проведённые занятия">
      <template v-if="drawerSubj">
        <div class="ld-dh">
          <div class="ld-dh-row">
            <h6>{{ drawerSubj.name }}</h6>
            <button type="button" class="ld-x" aria-label="Закрыть" @click="drawer = null">&times;</button>
          </div>
          <div class="ld-dsum">
            <span>{{ drawerSubj.groups.join(', ') }}</span>
            <span v-for="w in drawerSubj.works" :key="w.id" :class="'ld-t' + catIdx(w.cat)" :title="w.groups">{{ CAT[w.cat] || 'Др.' }} {{ w.done }}/{{ w.plan }} ч</span>
            <span>проведено: {{ drawerSubj.lessons.length }}</span>
            <span v-if="drawerSubj.notIss" class="ld-chip ld-chip-bad">не в ISS: {{ drawerSubj.notIss }}</span>
          </div>
        </div>
        <div class="ld-menu ld-menu-flat">
          <button type="button" class="ld-mi ld-mi-primary" :disabled="busy" @click="runAudit(drawer)">
            <b-icon icon="search" aria-hidden="true"></b-icon><span>Аудит этого предмета</span>
          </button>
          <button type="button" class="ld-mi" :disabled="busy || iss.loading" title="Загрузить записи ISS этого предмета: утверждены ли, удалить неутверждённые" @click="loadSubjectIss(drawer)">
            <b-icon icon="journal-text" aria-hidden="true"></b-icon><span>Журнал ISS</span>
          </button>
          <span v-if="iss.loading" class="ld-meta">загрузка {{ iss.done + 1 }} из {{ iss.total }}…</span>
          <span v-else-if="drawerIss" class="ld-meta">записей ISS: {{ drawerIss.count }}</span>
        </div>
        <div v-if="iss.failed.length && iss.subject === drawer" class="ld-warn ld-warn-pad">Не загрузился журнал: {{ iss.failed.join('; ') }}</div>
        <div class="ld-dlist">
          <p v-if="!drawerSubj.lessons.length" class="ld-empty">Проведённых занятий по расписанию нет.</p>
          <template v-for="m in drawerMonths">
            <div :key="m.name" class="ld-month">{{ m.name }}</div>
            <div v-for="l in m.lessons" :key="l.day + l.time" class="ld-lesson" :class="{ 'ld-lesson-no': !l.inIss }">
              <span class="ld-ld"><b>{{ shortDate(l.day) }}</b><small>{{ l.time }}</small></span>
              <span class="ld-lw"><span :class="'ld-t' + catIdx(l.cat)">{{ l.type }}</span><small>{{ l.groups.join(', ') }}<template v-if="l.subgroups"> · {{ subLabel(l.subgroups) }}</template></small></span>
              <span v-if="!drawerIss" class="ld-chip" :class="l.inIss ? 'ld-chip-ok' : 'ld-chip-bad'">{{ l.inIss ? 'в ISS' : 'не в ISS' }}</span>
              <span v-else class="ld-issact">
                <template v-if="drawerIss.byLesson[l.day + '|' + l.time]">
                  <template v-for="e in [drawerIss.byLesson[l.day + '|' + l.time]]">
                    <span v-if="deletedIds[e.id]" :key="e.id" class="ld-chip ld-chip-ok">✓ удалено</span>
                    <span v-else-if="e.approved" :key="e.id" class="ld-chip ld-chip-ok" title="Утверждённую запись ISS удалить нельзя">в ISS · утв.</span>
                    <template v-else>
                      <span :key="e.id" class="ld-chip ld-chip-warn" :title="'Запись ISS ' + e.time + ', ' + e.hours + ' ч, не утверждена'">в ISS{{ e.hours > 2 ? ' · ' + e.hours + ' ч' : '' }}</span>
                      <button :key="e.id + 'd'" type="button" class="ld-del" :disabled="!!deleting" :title="'Удалить запись ISS ' + e.date + ' ' + e.time" @click="deleteIssEntry(e.work, e, drawerSubj.name)">
                        <b-spinner v-if="deleting === e.id" small></b-spinner><b-icon v-else icon="trash" aria-label="Удалить из ISS"></b-icon>
                      </button>
                    </template>
                  </template>
                </template>
                <span v-else class="ld-chip ld-chip-bad">не в ISS</span>
              </span>
              <span v-if="drawerIss && drawerIss.byLesson[l.day + '|' + l.time] && delErrors[drawerIss.byLesson[l.day + '|' + l.time].id]" class="ld-delerr ld-delerr-row" role="alert">
                Не удалено: {{ delErrors[drawerIss.byLesson[l.day + '|' + l.time].id] }}
              </span>
            </div>
          </template>
          <template v-if="drawerIss && drawerIss.extra.length">
            <div class="ld-month">Только в ISS — нет в расписании</div>
            <div v-for="e in drawerIss.extra" :key="e.id" class="ld-lesson">
              <span class="ld-ld"><b>{{ shortDate(e.day) }}</b><small>{{ e.time }} · {{ e.hours }} ч</small></span>
              <span class="ld-lw"><span :class="'ld-t' + catIdx(e.work.cat)">{{ CATF[e.work.cat] || '' }}</span><small>{{ e.work.groups }}{{ e.kab ? ' · ' + e.kab : '' }}</small></span>
              <span class="ld-issact">
                <span v-if="deletedIds[e.id]" class="ld-chip ld-chip-ok">✓ удалено</span>
                <span v-else-if="e.approved" class="ld-chip ld-chip-ok" title="Утверждённую запись ISS удалить нельзя">утв.</span>
                <button v-else type="button" class="ld-del" :disabled="!!deleting" :title="'Удалить запись ISS ' + e.date + ' ' + e.time" @click="deleteIssEntry(e.work, e, drawerSubj.name)">
                  <b-spinner v-if="deleting === e.id" small></b-spinner><b-icon v-else icon="trash" aria-label="Удалить из ISS"></b-icon>
                </button>
              </span>
              <span v-if="delErrors[e.id]" class="ld-delerr ld-delerr-row" role="alert">Не удалено: {{ delErrors[e.id] }}</span>
            </div>
          </template>
        </div>
      </template>
    </aside>

    <!-- отчёт аудита -->
    <b-modal id="loadauditwin" size="lg" centered hide-footer :dialog-class="'ld-audit-dialog'" :title="auditTitle"
      :no-close-on-backdrop="audit.running" :no-close-on-esc="audit.running" @hide="onAuditHide">
      <div class="ld-audit-head">
        <div class="ld-dim">
          <template v-if="audit.running">Загрузка журнала ISS: работа {{ audit.done + 1 }} из {{ audit.total }}<span v-if="audit.current"> · {{ audit.current }}</span></template>
          <template v-else-if="report">Проверено работ: {{ report.checked.works }} · записей ISS: {{ report.checked.entries }} · проведённых занятий: {{ scopedLessonsCount }}</template>
        </div>
        <div class="ld-prog"><i :style="{ width: (audit.total ? audit.done / audit.total * 100 : 0) + '%' }"></i></div>
        <b-alert v-if="audit.error" show variant="danger" class="mt-2 mb-0">{{ audit.error }}</b-alert>
        <div v-if="report && report.synced" class="ld-synced">Отметки «в ISS» в расписании исправлены по журналу ISS: {{ report.synced }} {{ plural(report.synced, 'занятие', 'занятия', 'занятий') }}.</div>
        <div v-if="audit.failed.length" class="ld-warn">Не удалось загрузить журнал {{ audit.failed.length }} работ: {{ audit.failed.join('; ') }} — по ним отчёт неполный.</div>
      </div>
      <template v-if="report">
        <div class="ld-tiles" role="tablist">
          <button v-for="t in TILES" :key="t.k" type="button" role="tab" class="ld-tile"
            :class="[{ 'ld-tile-on': tab === t.k }, scoped[t.k].length ? 'ld-tile-' + t.level : 'ld-tile-zero']"
            :aria-selected="String(tab === t.k)" @click="tab = t.k">
            <b>{{ scoped[t.k].length }}</b><small>{{ t.title }}</small>
          </button>
        </div>
        <div class="ld-alist">
          <p class="ld-hint">{{ TILE[tab].hint }}</p>
          <p v-if="!scoped[tab].length" class="ld-empty">Не найдено.</p>
          <div v-for="(it, i) in scoped[tab]" :key="i" class="ld-aitem">
            <span class="ld-ld"><b>{{ it.day ? shortDate(it.day) : '—' }}</b><small>{{ it.time || '' }}</small></span>
            <span>
              <b>{{ itemTitle(tab, it) }}</b>
              <small>{{ itemText(tab, it) }}</small>
              <!-- записи ISS этой находки, которые можно удалить -->
              <span v-if="itemEntries(tab, it).length" class="ld-aacts">
                <span v-for="x in itemEntries(tab, it)" :key="x.entry.id" class="ld-aentry">
                  <span v-if="deletedIds[x.entry.id]" class="ld-chip ld-chip-ok">✓ удалено из ISS: {{ x.label }}</span>
                  <span v-else-if="movedIds[x.entry.id]" class="ld-chip ld-chip-ok">✓ перенесено: {{ x.label }}</span>
                  <span v-else-if="x.entry.approved" class="ld-chip ld-chip-ok" title="Утверждённую запись ISS нельзя ни удалить, ни перенести (снять «Утв.» можно только в ISS)">утверждено: {{ x.label }}</span>
                  <template v-else>
                    <button type="button" class="btn btn-sm btn-outline-danger ld-adel" :disabled="!!deleting || tr.running"
                      @click="deleteIssEntry(x.work, { ...x.entry, date: isoToRu(it.day) }, x.name)">
                      <b-spinner v-if="deleting === x.entry.id" small></b-spinner><b-icon v-else icon="trash" aria-hidden="true"></b-icon>
                      {{ deleting === x.entry.id ? 'Удаление…' : 'Удалить ' + x.label }}
                    </button>
                    <label v-if="canMark(x)" class="ld-mark" :title="'Отметить запись для переноса на свободную пару: ' + x.label">
                      <input type="checkbox" :checked="!!marks[markKey(x)]" @change="toggleMark(x, it, $event.target.checked)"> на перенос
                    </label>
                  </template>
                </span>
              </span>
              <span v-for="x in itemEntries(tab, it).filter(y => delErrors[y.entry.id])" :key="'err' + x.entry.id" class="ld-delerr" role="alert">
                Не удалено: {{ delErrors[x.entry.id] }}
              </span>
            </span>
          </div>
        </div>
        <div class="ld-af">
          <span class="ld-dim">Удаляются и переносятся только неутверждённые записи ISS — после подтверждения.</span>
          <span class="ld-afb">
            <button v-if="markedList.length" type="button" class="btn btn-sm btn-outline-secondary" @click="clearMarks">Снять отметки</button>
            <button type="button" class="btn btn-sm btn-primary" :disabled="!markedList.length || audit.running" @click="openTransfer">
              Перенести отмеченные ({{ markedList.length }})…
            </button>
            <button type="button" class="btn btn-sm btn-outline-primary" @click="exportAudit">Экспорт в Excel</button>
          </span>
        </div>
      </template>
      <div v-if="audit.running" class="ld-af">
        <span></span>
        <button type="button" class="btn btn-sm btn-outline-danger" @click="audit.cancel = true">Остановить</button>
      </div>
    </b-modal>

    <!-- внеаудиторная нагрузка: выбор разделов и работ, период дат, внесение целиком (остаток от 10 и больше ISS не принимает — частями) -->
    <b-modal id="loadnonaudwin" size="lg" centered scrollable hide-footer title="Внеаудиторная нагрузка" :no-close-on-backdrop="na.loading || na.running" :no-close-on-esc="na.loading || na.running" @hide="onNaHide">
      <p class="ld-dim mb-2">Нагрузка вносится <b>сразу вся по строке</b> — кнопкой «Закрыть» в карточке работы, без дробления. Если остаток нагрузки 10 и больше (например, 12,34), база ISS такую запись не принимает (ошибка переполнения): тогда остаток делится на равные части (каждая не больше 9,99), по одной записи на дату периода.</p>
      <div v-if="na.loading" class="ld-dim"><b-spinner small></b-spinner> Читаю внеаудиторную нагрузку из ISS…</div>
      <b-alert v-if="na.error" show variant="danger" class="mb-2">{{ na.error }}</b-alert>
      <p v-if="!na.loading && !na.error && !na.works.length" class="ld-empty">В нагрузке нет внеаудиторных работ.</p>
      <template v-if="na.works.length">
        <div class="ld-trform">
          <label>Вносить на даты с<input v-model="na.from" type="date" class="form-control form-control-sm" :disabled="na.running"></label>
          <label>по<input v-model="na.to" type="date" class="form-control form-control-sm" :disabled="na.running"></label>
        </div>
        <div class="ld-nafilter">
          <label class="ld-nafl">Показывать
            <select v-model="na.filter" class="form-control form-control-sm" @change="naSaveUi">
              <option value="all">все работы ({{ na.works.length }})</option>
              <option value="none">не внесённые — записей нет ({{ naCount('none') }})</option>
              <option value="part">внесённые частично ({{ naCount('part') }})</option>
              <option value="full">внесённые полностью ({{ naCount('full') }})</option>
            </select>
          </label>
          <span class="ld-nafold"><button type="button" class="ld-linkbtn" @click="naFoldAll(true)">свернуть все</button><button type="button" class="ld-linkbtn" @click="naFoldAll(false)">развернуть все</button></span>
        </div>
        <p class="ld-trnote">Запись, вносимая целиком, ставится на первую дату периода; части разложены по рабочим датам периода равномерно (воскресенья пропускаются), по одной записи на дату.</p>
        <div class="ld-nasec" v-for="sec in naSections" :key="sec.name">
          <div class="ld-nahead">
            <button type="button" class="ld-fold" :aria-expanded="String(!na.collapsed[sec.name])" :title="na.collapsed[sec.name] ? 'Развернуть раздел' : 'Свернуть раздел'" @click="naFold(sec.name)">
              <b-icon :icon="na.collapsed[sec.name] ? 'chevron-right' : 'chevron-down'" aria-hidden="true"></b-icon>
            </button>
            <label class="ld-nahl">
              <input type="checkbox" :checked="sec.all" :indeterminate.prop="sec.some && !sec.all" :disabled="na.running || !sec.free" @change="naToggleSection(sec, $event.target.checked)">
              <b>{{ sec.name || 'Без раздела' }}</b>
            </label>
            <span class="ld-dim">{{ sec.chosen ? 'выбрано ' + sec.chosen + ' · ' : '' }}{{ sec.free }} из {{ sec.works.length }} к внесению</span>
          </div>
          <label v-for="w in (na.collapsed[sec.name] ? [] : sec.works)" :key="w.id" class="ld-nawork" :class="{ 'ld-nawork-off': w.remain <= 0 }">
            <input v-model="na.checked[w.id]" type="checkbox" :disabled="na.running || w.remain <= 0 || !!na.results[w.id]">
            <span class="ld-nawhat"><b>{{ w.name }}</b><small>{{ w.groups }}</small></span>
            <span class="ld-nanum">{{ fmtH(w.done) }} / {{ fmtH(w.plan) }} АЕ</span>
            <span v-if="w.remain <= 0" class="ld-chip ld-chip-ok">выполнена</span>
            <span v-else class="ld-chip" :class="naParts(w) > 1 ? 'ld-chip-warn' : 'ld-chip-bad'" :title="naParts(w) > 1 ? 'Остаток 10 и больше — ISS не примет одной записью, будет несколько' : 'Остаток вносится одной записью'">осталось {{ fmtH(w.remain) }}{{ naParts(w) > 1 ? ' · частей: ' + naParts(w) : '' }}</span>
            <span v-if="na.results[w.id]" class="ld-chip" :class="na.results[w.id].ok ? 'ld-chip-ok' : 'ld-chip-bad'" :title="na.results[w.id].message">{{ na.results[w.id].label }}</span>
          </label>
        </div>
        <!-- плавающая панель: всегда видна внизу окна при прокрутке списка работ -->
        <div class="ld-nabar">
          <b-alert v-if="na.check" show :variant="na.check.ok ? 'success' : 'danger'" dismissible class="mb-2" @dismissed="na.check = null">{{ na.check.text }}</b-alert>
          <p v-if="naPeriodError" class="ld-trwarn">{{ naPeriodError }}</p>
          <p v-if="na.running || na.progress" class="ld-dim mb-1">{{ na.progress }}</p>
          <div v-if="na.done" class="ld-trbar">
            <span class="ld-dim">{{ na.summary }}</span>
            <button type="button" class="btn btn-sm btn-outline-primary" @click="naReload">Обновить из ISS</button>
          </div>
          <div class="ld-trbar">
            <span class="ld-nasum">Выбрано работ: {{ naChosen.length }}, записей: {{ naEntries }}, часов: {{ fmtH(naHours) }}</span>
            <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="na.running || !naChosen.length" title="Заполняет форму ISS для первой выбранной работы и закрывает её, ничего не сохраняя" @click="naRun(true)">Проверить форму ISS</button>
            <button type="button" class="btn btn-sm btn-danger" :disabled="na.running || !naChosen.length || !!naPeriodError" @click="naConfirm">
              <b-spinner v-if="na.running" small></b-spinner> Внести в ISS ({{ naChosen.length }})
            </button>
            <button v-if="na.running" type="button" class="btn btn-sm btn-outline-danger" @click="na.cancel = true">Остановить</button>
          </div>
        </div>
      </template>
    </b-modal>

    <!-- перенос отмеченных записей на свободные пары -->
    <b-modal id="loadtransferwin" size="lg" centered hide-footer title="Перенос записей ISS" :no-close-on-backdrop="tr.running || tr.planning" :no-close-on-esc="tr.running || tr.planning" @hide="onTransferHide">
      <p class="ld-dim mb-2">Отмечено записей: <b>{{ markedList.length }}</b>. Программа подберёт для каждой свободную пару — когда свободны вы и группа — и <b>изменит дату существующей записи</b> в журнале ISS. Утверждённые записи не переносятся: галочку «Утв.» здесь снять нельзя.</p>
      <div class="ld-trform">
        <label>Переносить на даты с<input v-model="tr.from" type="date" class="form-control form-control-sm" :disabled="tr.planning || tr.running"></label>
        <label>по<input v-model="tr.to" type="date" class="form-control form-control-sm" :disabled="tr.planning || tr.running"></label>
        <label>Пар в день не больше<input v-model.number="tr.maxPerDay" type="number" min="1" max="7" class="form-control form-control-sm" :disabled="tr.planning || tr.running"></label>
      </div>
      <label class="ld-trchk" title="Расписание групп берётся из чат-бота ВятГУ на сервере. Чат показывает только текущую и ближайшие недели."><input v-model="tr.useChat" type="checkbox" :disabled="tr.planning || tr.running"> учитывать расписание учебных групп (чат-бот ВятГУ)</label>
      <div class="ld-trbar">
        <button type="button" class="btn btn-sm btn-primary" :disabled="tr.planning || tr.running" @click="makePlan"><b-spinner v-if="tr.planning" small></b-spinner> Составить план</button>
        <button v-if="tr.planning" type="button" class="btn btn-sm btn-outline-danger" @click="cancelPlan">Остановить</button>
        <span v-if="tr.planning" class="ld-dim">{{ tr.progress }}</span>
      </div>
      <b-alert v-if="tr.error" show variant="danger" class="mt-2 mb-0">{{ tr.error }}</b-alert>
      <b-alert v-if="tr.check" show variant="success" dismissible class="mt-2 mb-0" @dismissed="tr.check = null">{{ tr.check.text }}</b-alert>
      <template v-if="tr.plan">
        <p v-for="(n, i) in tr.plan.notes" :key="'n' + i" class="ld-trnote">{{ n }}</p>
        <div v-if="tr.plan.unplaced.length" class="ld-trun">
          <b>Не удалось подобрать место ({{ tr.plan.unplaced.length }}):</b>
          <div v-for="(u, i) in tr.plan.unplaced" :key="'u' + i">{{ trItemLabel(u.items[0]) }} — {{ u.detail }}</div>
        </div>
        <div v-if="tr.plan.placements.length" class="ld-trlist">
          <div v-for="p in tr.plan.placements" :key="p.key" class="ld-trrow">
            <label class="ld-tritem" :class="{ 'ld-tritem-done': tr.results[p.key] }">
              <input v-model="tr.checked[p.key]" type="checkbox" :disabled="tr.running || !!tr.results[p.key]">
              <span class="ld-trwhen">{{ shortDate(p.from.day) }} {{ pairTimeOf(p.from.pair) }}<i> → </i><b>{{ shortDate(p.toDay) }} {{ pairTimeOf(p.toPair) }}</b></span>
              <span class="ld-trwhat"><b>{{ p.workName }}</b><small>{{ p.hours }} ч{{ p.kab ? ', ' + p.kab : '' }}<template v-if="p.manual"> · выбрано вручную</template><template v-else>{{ p.roomFree ? '' : ' · аудитория может быть занята' }}{{ p.groupsVerified ? ' · группы проверены по чату' : ' · группы без чата' }}</template></small></span>
              <span v-if="tr.results[p.key]" class="ld-chip" :class="tr.results[p.key].ok ? 'ld-chip-ok' : 'ld-chip-bad'" :title="tr.results[p.key].message">{{ tr.results[p.key].label }}</span>
              <button v-else type="button" class="btn btn-sm btn-outline-secondary" :disabled="tr.running" @click.prevent="toggleEdit(p)">{{ tr.editKey === p.key ? 'Свернуть' : 'Изменить' }}</button>
            </label>
            <div v-if="tr.editKey === p.key && !tr.results[p.key]" class="ld-tredit">
              <div class="ld-trdays" role="group" aria-label="Даты окна: число свободных мест">
                <button v-for="d in gridDays(p)" :key="d" type="button" class="ld-trday" :class="{ on: d === p.toDay, free: freeCount(p, d) > 0 }" @click="setDay(p, d)">{{ shortDate(d) }}<small>{{ freeCount(p, d) ? 'своб. ' + freeCount(p, d) : 'занято' }}</small></button>
              </div>
              <div class="ld-trform ld-trform2">
                <label>Дата<input type="date" class="form-control form-control-sm" :value="p.toDay" @change="setDay(p, $event.target.value)"></label>
                <label>Кабинет<input type="text" class="form-control form-control-sm" maxlength="10" :value="p.kab" @change="setKab(p, $event.target.value)"></label>
              </div>
              <div class="ld-trpairs" role="group" aria-label="Время пары">
                <button v-for="n in 7" :key="n" type="button" class="ld-trpair" :class="['ld-slot-' + slotCode(p, p.toDay, n), { on: n === p.toPair }]" @click="setPair(p, n)">{{ n }} · {{ pairTimeOf(n) }}<small>{{ SLOT_TITLE[slotCode(p, p.toDay, n)] }}</small></button>
              </div>
              <p v-if="slotCode(p, p.toDay, p.toPair) !== '0'" class="ld-trwarn">Выбранное место: {{ SLOT_TITLE[slotCode(p, p.toDay, p.toPair)] }}. Перенос возможен, но проверьте, что это не ошибка.</p>
              <p class="ld-trnote">Свободные места — по журналам ISS, вашему расписанию и (если включено) чат-боту. Если кабинета нет в списке ISS, останется прежний; у дистанционных занятий кабинет не меняется.</p>
              <button v-if="p.manual" type="button" class="btn btn-sm btn-outline-secondary" @click="resetPlacement(p)">Вернуть подобранное</button>
            </div>
          </div>
        </div>
        <p v-else class="ld-empty mt-2">Подходящих мест в этом окне дат нет — расширьте окно или уменьшите число отмеченных записей.</p>
        <div v-if="tr.plan.placements.length" class="ld-trbar">
          <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="tr.running || !checkedPlacements.length" title="Заполняет форму ISS для первой отмеченной записи и закрывает её, ничего не сохраняя" @click="runMoves(true)">Проверить форму ISS</button>
          <button type="button" class="btn btn-sm btn-danger" :disabled="tr.running || !checkedPlacements.length" @click="confirmMoves">
            <b-spinner v-if="tr.running" small></b-spinner> Перенести в ISS ({{ checkedPlacements.length }})
          </button>
          <button v-if="tr.running" type="button" class="btn btn-sm btn-outline-danger" @click="tr.cancel = true">Остановить</button>
          <span v-if="tr.running" class="ld-dim">{{ tr.progress }}</span>
        </div>
        <div v-if="tr.done" class="ld-trbar">
          <span class="ld-dim">{{ tr.summary }}</span>
          <button type="button" class="btn btn-sm btn-outline-primary" @click="rerunAudit">Повторить аудит</button>
        </div>
      </template>
    </b-modal>
  </b-modal>
</template>

<script>
import { utils, writeFile } from 'xlsx'
import nonAudit from '../../../../lib/nonAudit'

const PATH = process.env.VUE_APP_PATH
const WEEKDAYS = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб']
const MONTHS = ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь']
const CAT = { 0: 'Лек', 1: 'Пр', 2: 'Лаб', 9: 'Конс', 10: 'Экз', 11: 'Зач' }
const CATF = { 0: 'Лекции', 1: 'Практики', 2: 'Лабораторные', 9: 'Консультации', 10: 'Экзамены', 11: 'Зачёты' }
const STATUS = { ok: 'в графике', warn: 'немного отстаёт', bad: 'отстаёт' }
const TILES = [
  { k: 'unrecorded', title: 'не записано в ISS', level: 'bad', hint: 'Занятие есть в расписании и уже прошло, а записи в журнале ISS на эту пару нет.' },
  { k: 'duplicate', title: 'дубли записей', level: 'bad', hint: 'В одной работе ISS на одну пару приходятся две записи — часы засчитаны дважды.' },
  { k: 'overlap', title: 'два занятия в одно время', level: 'bad', hint: 'Записи разных работ ISS приходятся на одну и ту же пару.' },
  { k: 'extra', title: 'в ISS, нет в расписании', level: 'warn', hint: 'Запись в ISS есть, а занятия в расписании в эту пару нет (перенос, ручная запись или удалённое занятие). Записи на будущие даты сверяются со всем расписанием.' },
  { k: 'overplan', title: 'перебор плана', level: 'warn', hint: 'Записано часов больше, чем по плану работы.' },
  { k: 'nowork', title: 'нет работы в нагрузке', level: 'warn', hint: 'Проведённые занятия, которые некуда записать: в нагрузке ISS нет работы с тем же предметом, видом занятий и группой, или тип занятия не относится к видам работ ISS.' },
]
const TYPECAT = t => {
  t = String(t || '').toLowerCase()
  if (t.startsWith('лек')) return 0
  if (t.startsWith('практ') || t.startsWith('семин')) return 1
  if (t.startsWith('лаб')) return 2
  if (t.startsWith('консульт')) return 9
  if (t.startsWith('экзам')) return 10
  if (t.startsWith('зач') || t.startsWith('дифф')) return 11
  return -1
}
// номер пары 1..7 по времени "8:20-9:50" / "8:20"
const PAIR_STARTS = ['8:20', '10:00', '11:45', '14:00', '15:45', '17:20', '18:55']
const PAIR = t => PAIR_STARTS.indexOf(String(t || '').split('-')[0].replace(/^0(\d)/, '$1')) + 1
// ключ набора групп/подгрупп как на сервере (lib/issJournal.js#groupsKey)
const groupsKeyOf = str => {
  const re = /([А-ЯЁA-Z][А-ЯЁа-яёA-Za-z]*-\d{4}-\d{2}-\d{2})(?:,\s*(?:(\d+)\s*подгруппа|подгруппа\s*(\d+)))?/g
  const out = []
  let m
  while ((m = re.exec(String(str || '')))) out.push(m[1] + ((m[2] || m[3]) ? '#' + Number(m[2] || m[3]) : ''))
  return [...new Set(out)].sort().join('|')
}
const localToday = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

// Дашборд «Выполнение нагрузки»: работы ISS (/api/iss/worklist) + проведённые
// занятия по расписанию (days). Аудит: журнал каждой работы — /api/iss/worklist/lessons
// (по одной, с прогрессом), затем сверка на сервере — /api/iss/audit (lib/issAudit.js).
export default {
  name: 'loadDashWin',
  props: {
    works: { type: Array, default: () => [] },
    days: { type: Array, default: () => [] },
    login: String,
    passwordAES: String,
    semester: [String, Number],
    busy: Boolean,
  },
  beforeDestroy() { clearTimeout(this.planTimer) },
  data() {
    return {
      CAT, CATF, STATUS, TILES,
      TILE: Object.fromEntries(TILES.map(t => [t.k, t])),
      mode: 'table',
      expanded: null,
      drawer: null,
      today: localToday(),
      audit: { running: false, done: 0, total: 0, current: '', failed: [], error: '', cancel: false, scope: null },
      report: null,
      tab: 'unrecorded',
      // удаление записей ISS
      deleting: null,
      deletedIds: {},
      delErrors: {},
      // внеаудиторная нагрузка: список работ из ISS, выбор, период дат, ход внесения
      na: { loading: false, running: false, cancel: false, error: '', works: [], checked: {}, results: {}, from: '', to: '', progress: '', done: false, summary: '', check: null, filter: 'all', collapsed: {} },
      // перенос записей ISS (отметки, план, ход)
      marks: {},
      movedIds: {},
      auditWorks: [],
      planTimer: null,
      SLOT_TITLE: { 0: 'свободно', 1: 'вы заняты', 2: 'группа занята', 3: 'кабинет занят', 4: 'занято другим переносом', 9: 'не помещается', '?': 'нет данных' },
      tr: { check: null, editKey: '', from: '', to: '', maxPerDay: 4, useChat: true, planning: false, running: false, cancel: false, progress: '', error: '', plan: null, checked: {}, results: {}, done: false, summary: '', jobId: '' },
      // журнал ISS предмета в окне предмета
      iss: { subject: null, loading: false, done: 0, total: 0, entries: null, failed: [] },
    }
  },
  computed: {
    // разделы внеаудиторной нагрузки (как группы в таблице ISS) с выбором целиком
    naSections() {
      const map = new Map()
      this.naVisible.forEach(w => { if (!map.has(w.catName)) map.set(w.catName, []); map.get(w.catName).push(w) })
      return [...map].map(([name, works]) => {
        const free = works.filter(w => w.remain > 0 && !this.na.results[w.id])
        return { name, works, free: free.length, all: free.length > 0 && free.every(w => this.na.checked[w.id]), some: free.some(w => this.na.checked[w.id]), chosen: works.filter(w => this.na.checked[w.id] && w.remain > 0).length }
      })
    },
    // работы, прошедшие фильтр «внесена / не внесена»; выбранные, но скрытые фильтром, во внесение не попадают
    naVisible() { return this.na.works.filter(w => this.naKind(w) === this.na.filter || this.na.filter === 'all') },
    naChosen() { return this.naVisible.filter(w => this.na.checked[w.id] && w.remain > 0 && !this.na.results[w.id]) },
    naEntries() { return this.naChosen.reduce((a, w) => a + this.naParts(w), 0) },
    naHours() { return this.naChosen.reduce((a, w) => a + w.remain, 0) },
    naPeriodError() {
      const { from, to } = this.na
      if (!from || !to || from > to) return 'Укажите период дат: «с» не позже «по».'
      const need = Math.max(0, ...this.naChosen.map(w => this.naParts(w)))
      return nonAudit.spreadDates(from, to, need || 1) ? '' : `В периоде не хватает рабочих дат: для самой длинной нагрузки нужно записей — ${need} (по одной на дату).`
    },
    markedList() { return Object.values(this.marks) },
    checkedPlacements() { return this.tr.plan ? this.tr.plan.placements.filter(p => this.tr.checked[p.key] && !this.tr.results[p.key]) : [] },
    // занятия по расписанию, уже прошедшие
    held() {
      const out = []
      this.days.forEach(d => {
        if (d.day > this.today) return
        ;(d.lessons || []).forEach(l => {
          if (!l.predm) return
          out.push({ day: d.day, time: l.time, predm: l.predm, type: l.type, cat: TYPECAT(l.type), groups: l.groups || [], subgroups: l.subgroups || '', inIss: String(l.in_iss) === '1' })
        })
      })
      return out
    },
    subjects() {
      const map = new Map()
      this.works.forEach(w => {
        if (!map.has(w.name)) map.set(w.name, { name: w.name, works: [], groups: new Set() })
        const m = String(w.info || '').match(/(\d+)\s*\/\s*(\d+)/)
        const s = map.get(w.name)
        s.works.push({ ...w, done: m ? Number(m[1]) : 0, plan: m ? Number(m[2]) : 0 })
        String(w.groups).split(', ').forEach(g => s.groups.add(g))
      })
      return [...map.values()].map(s => {
        const done = s.works.reduce((a, w) => a + w.done, 0)
        const plan = s.works.reduce((a, w) => a + w.plan, 0)
        const p = plan ? done / plan : 0
        const cats = new Set(s.works.map(w => w.cat))
        const lessons = this.held.filter(l => l.predm === s.name && cats.has(l.cat))
        const byCat = {}
        const multi = {}
        s.works.forEach(w => {
          byCat[w.cat] = byCat[w.cat] || { done: 0, plan: 0 }
          byCat[w.cat].done += w.done
          byCat[w.cat].plan += w.plan
          multi[w.cat] = (multi[w.cat] || 0) + 1
        })
        Object.keys(multi).forEach(c => { multi[c] = multi[c] > 1 })
        return {
          name: s.name, works: s.works, groups: [...s.groups].sort(), done, plan, pct: p, byCat, multi,
          lessons, lessonsDesc: [...lessons].sort((a, b) => (a.day + a.time < b.day + b.time ? 1 : -1)),
          notIss: lessons.filter(l => !l.inIss).length,
          status: p >= this.pace - 0.05 ? 'ok' : p >= this.pace - 0.15 ? 'warn' : 'bad',
        }
      }).sort((a, b) => a.name.localeCompare(b.name, 'ru'))
    },
    shownCats() {
      const cats = new Set()
      this.works.forEach(w => cats.add(w.cat))
      return [0, 1, 2, 9, 10, 11].filter(c => cats.has(c))
    },
    total() {
      return { done: this.subjects.reduce((a, s) => a + s.done, 0), plan: this.subjects.reduce((a, s) => a + s.plan, 0) }
    },
    lagging() {
      return this.subjects.filter(s => s.status !== 'ok').length
    },
    notIssTotal() {
      return this.subjects.reduce((a, s) => a + s.notIss, 0)
    },
    outside() {
      const names = new Set(this.works.map(w => w.name))
      return this.held.filter(l => !names.has(l.predm)).length
    },
    // доля прошедшего семестра (1-й: сентябрь–декабрь, 2-й: февраль–июнь)
    pace() {
      const now = new Date(this.today + 'T00:00:00')
      const y = now.getFullYear()
      let a, b
      if (String(this.semester) === '2') { a = new Date(y, 1, 9); b = new Date(y, 5, 30) } else {
        const sy = now.getMonth() < 7 ? y - 1 : y
        a = new Date(sy, 8, 1); b = new Date(sy, 11, 28)
      }
      return Math.min(1, Math.max(0, (now - a) / (b - a)))
    },
    drawerSubj() {
      return this.drawer === null ? null : this.subjects[this.drawer] || null
    },
    drawerMonths() {
      const out = []
      ;(this.drawerSubj ? this.drawerSubj.lessonsDesc : []).forEach(l => {
        const name = MONTHS[Number(l.day.slice(5, 7)) - 1]
        if (!out.length || out[out.length - 1].name !== name) out.push({ name, lessons: [] })
        out[out.length - 1].lessons.push(l)
      })
      return out
    },
    // записи ISS предмета: к занятию (день|время) — его запись, остальные — «только в ISS»
    drawerIss() {
      if (this.iss.subject !== this.drawer || !this.iss.entries || !this.drawerSubj) return null
      const byLesson = {}
      const used = new Set()
      this.drawerSubj.lessons.forEach(l => {
        const pair = PAIR(l.time)
        const e = this.iss.entries.find(x => x.day === l.day && x.work.cat === l.cat && x.pairs.includes(pair) && (x.groupsMatch(l)))
        if (e) { byLesson[l.day + '|' + l.time] = e; used.add(e.id) }
      })
      const extra = this.iss.entries.filter(e => !used.has(e.id) && e.day <= this.today)
      return { byLesson, extra, count: this.iss.entries.length }
    },
    auditTitle() {
      const s = this.audit.scope === null ? null : this.subjects[this.audit.scope]
      return 'Аудит проведённых занятий' + (s ? ' · ' + s.name : '')
    },
    // отчёт по предмету — только его записи (сервер сверяет со всем расписанием)
    scoped() {
      const r = this.report || {}
      const s = this.audit.scope === null ? null : this.subjects[this.audit.scope]
      const inScope = it => !s || it.predm === s.name || (it.workName || '').startsWith(s.name + ' · ') ||
        (it.works || []).some(w => (w.workName || '').startsWith(s.name + ' · '))
      return Object.fromEntries(TILES.map(t => [t.k, (r[t.k] || []).filter(inScope)]))
    },
    scopedLessonsCount() {
      const s = this.audit.scope === null ? null : this.subjects[this.audit.scope]
      return s ? s.lessons.length : (this.report ? this.report.checked.lessons : 0)
    },
  },
  methods: {
    onShow() {
      this.today = localToday()
      this.expanded = null
      let saved = null
      try { saved = localStorage.loadDashMode } catch (e) { /* без памяти */ }
      // по умолчанию: телефон — карточки, компьютер — таблица
      this.mode = saved === 'cards' || saved === 'table' ? saved : (window.matchMedia('(max-width: 767.98px)').matches ? 'cards' : 'table')
    },
    setMode(m) {
      this.mode = m
      try { localStorage.loadDashMode = m } catch (e) { /* без памяти */ }
    },
    pct(a, b) {
      return b ? Math.min(100, a / b * 100) : 0
    },
    ring(p) {
      const c = 2 * Math.PI * 22
      return `${c * Math.min(1, p)} ${c}`
    },
    statusColor(s) {
      return s === 'ok' ? 'var(--success)' : s === 'warn' ? 'var(--warning)' : 'var(--danger)'
    },
    catIdx(c) {
      return [0, 1, 2].includes(Number(c)) ? Number(c) : 3
    },
    shortGroups(g) {
      // "БИб-4601-01-54" -> "4601-01-54": различает группы одного направления
      return String(g).split(', ').map(x => x.split('-').slice(1).join('-')).join(', ')
    },
    subLabel(s) {
      const n = [...new Set((String(s).match(/\d+(?= подгруппа)/g) || []))]
      return n.length ? n.join(', ') + ' подгр.' : ''
    },
    shortDate(day) {
      const [y, m, d] = day.split('-')
      return `${WEEKDAYS[new Date(Number(y), Number(m) - 1, Number(d)).getDay()]} ${d}.${m}`
    },
    openSubject(k) {
      this.drawer = k
    },
    isoToRu(day) {
      return day.split('-').reverse().join('.')
    },
    // журнал ISS всех работ предмета (по одной работе)
    async loadSubjectIss(k) {
      const s = this.subjects[k]
      this.iss = { subject: k, loading: true, done: 0, total: s.works.length, entries: null, failed: [] }
      const auth = { login: this.login, passwordAES: this.passwordAES, semester: this.semester }
      const entries = []
      for (const w of s.works) {
        try {
          const { data } = await this.axios.post(PATH + '/api/iss/worklist/lessons', { auth, data: { id: w.id, quiet: true } }, { timeout: 60000 })
          if (!Array.isArray(data)) throw new Error()
          const wkey = groupsKeyOf(w.groups)
          data.forEach(r => {
            const [d, t] = String(r[0] || '').split(' ')
            const time = String(t || '').split(':').slice(0, 2).join(':')
            const hours = Number(r[1]) || 0
            const start = PAIR(time)
            entries.push({
              work: w, id: String(r[5] != null ? r[5] : ''), date: d, day: this.ruToIso(d), time, hours, kab: r[2] || '',
              approved: r[4] === true || r[4] === 'true',
              pairs: Array.from({ length: Math.max(1, Math.ceil(hours / 2)) }, (_, i) => start + i),
              groupsMatch: l => groupsKeyOf(l.groups.join(', ')) === wkey || (!!l.subgroups && groupsKeyOf(l.subgroups) === wkey),
            })
          })
        } catch (e) {
          this.iss.failed.push(`${w.name} (${CAT[w.cat] || w.cat})`)
        }
        this.iss.done++
      }
      this.iss.entries = entries
      this.iss.loading = false
    },
    ruToIso(d) {
      return String(d || '').split('.').reverse().join('-')
    },
    // записи ISS находки аудита, которые можно удалить
    itemEntries(k, it) {
      const nameOf = id => { const w = this.works.find(x => x.id === id); return w ? w.name : '' }
      if ((k === 'extra' || k === 'duplicate') && it.entry) {
        return [{ work: this.works.find(x => x.id === it.work), entry: it.entry, name: nameOf(it.work), label: k === 'duplicate' ? 'дубль' : 'запись ISS' }]
      }
      if (k === 'overlap') {
        return it.works.filter(w => w.entry).map(w => ({ work: this.works.find(x => x.id === w.work), entry: w.entry, name: nameOf(w.work), label: `${nameOf(w.work)} (${CAT[w.cat] || ''})` }))
      }
      return []
    },
    // удалить НЕутверждённую запись ISS (после подтверждения)
    async deleteIssEntry(work, e, name) {
      if (!work || !e || !e.id || e.approved) return
      const ok = await this.$bvModal.msgBoxConfirm(
        `Удалить из ISS запись ${e.date} ${e.time}, ${e.hours} ч — «${work.name}», ${CATF[work.cat] || ''}, ${work.groups}? Отменить удаление нельзя.`,
        { title: 'Удаление записи ISS', okTitle: 'Удалить', okVariant: 'danger', cancelTitle: 'Отмена', centered: true, size: 'sm' })
      if (!ok) return
      this.deleting = e.id
      this.$delete(this.delErrors, e.id)
      const fail = msg => {
        this.$set(this.delErrors, e.id, msg)
        this.$root.$bvToast.toast(msg, { title: 'Запись ISS не удалена', variant: 'danger', solid: true, autoHideDelay: 10000, toaster: 'b-toaster-bottom-right' })
      }
      try {
        const { data } = await this.axios.post(PATH + '/api/iss/worklist/delete', {
          auth: { login: this.login, passwordAES: this.passwordAES, semester: this.semester },
          data: { id: work.id, date: e.date, time: e.time, entryId: Number(e.id), name },
        }, { timeout: 90000 })
        if (data.deleted) {
          this.$set(this.deletedIds, e.id, true)
          this.clearLocalIss(name, e)
          this.$root.$bvToast.toast(`Запись ${e.date} ${e.time} удалена из ISS.`, { title: 'ISS', variant: 'success', solid: true, autoHideDelay: 5000, toaster: 'b-toaster-bottom-right' })
        } else {
          fail(data.error || 'ISS не подтвердил удаление.')
        }
      } catch (err) {
        fail((err.response && err.response.data && err.response.data.error) || (err.code === 'ECONNABORTED' ? 'ISS не ответил за 90 с — проверьте журнал работы и повторите.' : 'Сервер не ответил.'))
      } finally {
        this.deleting = null
      }
    },
    // отметки «в ISS» по журналу ISS (сервер уже записал их в БД) — в расписание дашборда
    applyMarks(marks) {
      const byKey = new Map(marks.map(m => [`${m.day}|${m.time}|${m.predm}`, m.in_iss]))
      this.days.forEach(d => (d.lessons || []).forEach(l => {
        const v = byKey.get(`${d.day}|${l.time}|${l.predm}`)
        if (v !== undefined) l.in_iss = v
      }))
    },
    plural(n, one, few, many) {
      const n10 = n % 10, n100 = n % 100
      if (n10 === 1 && n100 !== 11) return one
      if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return few
      return many
    },
    // как на сервере: у занятий, покрытых удалённой записью, снимается «в ISS»
    clearLocalIss(name, e) {
      const day = this.ruToIso(e.date)
      const start = PAIR(e.time)
      const pairs = Array.from({ length: Math.max(1, Math.ceil(e.hours / 2)) }, (_, i) => start + i)
      const d = this.days.find(x => x.day === day)
      if (!d) return
      d.lessons.forEach(l => { if (l.predm === name && pairs.includes(PAIR(l.time))) l.in_iss = 0 })
    },
    // --- аудит ---
    async runAudit(scope) {
      const works = scope === null ? this.works : this.subjects[scope].works
      this.report = null
      this.marks = {}
      this.movedIds = {}
      this.auditWorks = []
      this.tab = 'unrecorded'
      this.audit = { running: true, done: 0, total: works.length, current: '', failed: [], error: '', cancel: false, scope }
      this.$bvModal.show('loadauditwin')
      const auth = { login: this.login, passwordAES: this.passwordAES, semester: this.semester }
      const collected = []
      for (const w of works) {
        if (this.audit.cancel) break
        this.audit.current = `${w.name} · ${CAT[w.cat] || ''}`
        try {
          const { data } = await this.axios.post(PATH + '/api/iss/worklist/lessons', { auth, data: { id: w.id, quiet: true } }, { timeout: 60000 })
          if (Array.isArray(data)) collected.push({ id: w.id, name: w.name, cat: w.cat, groups: w.groups, info: w.info, log: data })
          else this.audit.failed.push(`${w.name} (${CAT[w.cat] || w.cat})`)
        } catch (e) {
          this.audit.failed.push(`${w.name} (${CAT[w.cat] || w.cat})`)
        }
        this.audit.done++
      }
      this.audit.current = ''
      if (this.audit.cancel && !collected.length) {
        this.audit.running = false
        this.$bvModal.hide('loadauditwin')
        return
      }
      try {
        const { data } = await this.axios.post(PATH + '/api/iss/audit', { login: this.login, passwordAES: this.passwordAES, works: collected, today: this.today })
        this.report = data
        this.auditWorks = collected
        this.applyMarks(data.marks || [])
        const first = TILES.find(t => this.scoped[t.k].length)
        this.tab = first ? first.k : 'unrecorded'
      } catch (e) {
        this.audit.error = (e.response && e.response.data && e.response.data.error) || 'Не удалось выполнить аудит.'
      } finally {
        this.audit.running = false
      }
    },
    onAuditHide(e) {
      if (this.audit.running) e.preventDefault()
    },
    itemTitle(k, it) {
      if (k === 'unrecorded' || k === 'nowork') return `${it.predm} · ${it.type}`
      if (k === 'overlap') return 'Разные работы в одну пару'
      return it.workName
    },
    itemText(k, it) {
      if (k === 'unrecorded') return `${(it.groups || []).join(', ')} — занятие есть в расписании, записи в ISS нет`
      if (k === 'nowork') return it.reason === 'type'
        ? `${(it.groups || []).join(', ')} — тип «${it.type || 'не указан'}» не относится к видам работ ISS (лекции, практики, лабораторные, консультации, экзамены, зачёты)`
        : `${(it.groups || []).join(', ')} — в нагрузке ISS нет такой работы`
      if (k === 'duplicate') return `${CATF[it.cat] || ''}: две записи на одну пару (${it.hours.join(' ч и ')} ч)`
      if (k === 'overlap') return it.works.map(w => `${w.workName} (${CAT[w.cat] || ''})`).join(' и ')
      if (k === 'extra') return `${CATF[it.cat] || ''}: запись ISS на ${it.hours} ч${it.kab ? ', ' + it.kab : ''}${it.future ? ' на будущую дату' : ''} — в расписании в эту пару занятия нет`
      if (k === 'overplan') return `${CATF[it.cat] || ''}: записано ${it.done} ч при плане ${it.plan} ч`
      return ''
    },
    // --- внеаудиторная нагрузка ---
    fmtH(v) { return String(Math.round(v * 100) / 100).replace('.', ',') },
    // внесена ли нагрузка: none — записей нет (ничего не внесено), part — внесена частично, full — внесена полностью
    naKind(w) { return w.remain <= 0 ? 'full' : (w.done > 0 ? 'part' : 'none') },
    naCount(k) { return this.na.works.filter(w => this.naKind(w) === k).length },
    naFold(name) { this.$set(this.na.collapsed, name, !this.na.collapsed[name]); this.naSaveUi() },
    naFoldAll(on) { this.naSections.forEach(sec => this.$set(this.na.collapsed, sec.name, on)); this.naSaveUi() },
    // фильтр и свёрнутые разделы запоминаются в браузере (на этом компьютере)
    naSaveUi() { try { localStorage.setItem('nonaud.ui', JSON.stringify({ filter: this.na.filter, collapsed: this.na.collapsed })) } catch (e) { /* без памяти браузера */ } },
    naLoadUi() {
      try {
        const u = JSON.parse(localStorage.getItem('nonaud.ui') || '{}')
        if (['all', 'none', 'part', 'full'].includes(u.filter)) this.na.filter = u.filter
        if (u.collapsed && typeof u.collapsed === 'object') this.na.collapsed = { ...u.collapsed }
      } catch (e) { /* нет сохранённых настроек */ }
    },
    naParts(w) { return nonAudit.splitHours(w.remain).length },
    naToggleSection(sec, on) { sec.works.filter(w => w.remain > 0 && !this.na.results[w.id]).forEach(w => this.$set(this.na.checked, w.id, on)) },
    onNaHide(e) { if (this.na.loading || this.na.running) e.preventDefault() },
    openNonAudit() {
      this.naLoadUi()
      const t = localToday()
      const from = new Date(Date.parse(t + 'T00:00:00Z') - 6 * 86400000).toISOString().slice(0, 10)
      this.na = { ...this.na, from, to: t, results: {}, done: false, summary: '', progress: '', cancel: false, error: '' }
      this.$bvModal.show('loadnonaudwin')
      this.naReload()
    },
    async naReload() {
      this.na.loading = true; this.na.error = ''; this.na.done = false
      try {
        const { data } = await this.axios.post(PATH + '/api/iss/nonaudit/list', { auth: { login: this.login, passwordAES: this.passwordAES, semester: this.semester } }, { timeout: 90000 })
        if (!Array.isArray(data)) throw new Error('ISS не вернул список работ')
        this.na.works = data
        this.na.checked = {}
        this.na.results = {}
      } catch (e) {
        this.na.error = (e.response && e.response.data && e.response.data.error) || e.message || 'Не удалось прочитать внеаудиторную нагрузку.'
      } finally {
        this.na.loading = false
      }
    },
    async naConfirm() {
      const works = this.naChosen.length, entries = this.naEntries
      const split = this.naChosen.filter(w => this.naParts(w) > 1).length
      const ok = await this.$bvModal.msgBoxConfirm(
        `В журнале ISS будет внесено записей: ${entries} по ${works} ${this.plural(works, 'работе', 'работам', 'работам')} (${this.fmtH(this.naHours)} ч).${split ? ` Разбито на части из-за ошибки ISS (остаток от 10 и больше): ${split}.` : ''} Каждая запись проверяется по журналу после сохранения. Внесённую запись можно удалить в ISS, пока она не утверждена.`,
        { title: 'Внести нагрузку в ISS?', okTitle: 'Внести', okVariant: 'danger', cancelTitle: 'Отмена', centered: true, size: 'sm' })
      if (ok) this.naRun(false)
    },
    // одна запись: весь остаток (hours = null) или часть; ответ needsSplit — остаток оказался из 4+ цифр, надо дробить
    async naPost(w, date, hours, check, expected) {
      try {
        const { data } = await this.axios.post(PATH + '/api/iss/nonaudit/record', {
          auth: { login: this.login, passwordAES: this.passwordAES, semester: this.semester },
          data: { id: w.id, name: w.name, catName: w.catName, groups: w.groups, date: this.isoToRu(date), ...(hours == null ? {} : { hours }), ...(expected == null ? {} : { expected }), check: !!check },
        }, { timeout: 120000 })
        return data
      } catch (e) {
        return { added: false, error: (e.response && e.response.data && e.response.data.error) || (e.code === 'ECONNABORTED' ? 'ISS не ответил за 120 с — проверьте журнал работы в ISS.' : 'Сервер не ответил.') }
      }
    },
    async naRun(check) {
      const na = this.na
      const list = check ? this.naChosen.slice(0, 1) : this.naChosen
      if (!list.length) return
      na.running = true; na.cancel = false; na.error = ''; na.done = false; na.summary = ''; na.check = null
      let added = 0, failed = 0, hours = 0
      for (let i = 0; i < list.length; i++) {
        if (na.cancel) break
        const w = list[i]
        na.progress = `${check ? 'проверка формы' : 'внесение'}: ${i + 1} из ${list.length} · ${w.name}`
        // сначала — весь остаток; запись целиком, пока ISS её принимает
        let r = await this.naPost(w, na.from, null, check, w.remain)
        let label = '', ok = false, message = ''
        if (check) {
          ok = !!r.checked || !!r.needsSplit
          label = r.needsSplit ? 'форма в порядке (остаток из 4+ цифр — будет разбит)' : (r.checked ? 'форма в порядке' : 'ошибка')
          message = r.error || ''
          this.$set(na.results, w.id, { ok, label, message })
          na.running = false
          na.progress = ''
          this.$delete(na.results, w.id)
          // результат остаётся в панели внизу окна, пока его не закроют: раньше он мигал всплывающим сообщением
          if (r.needsSplit) {
            const plan = nonAudit.plan(r.remaining, na.from, na.to)
            na.check = { ok: true, text: `Форма «${w.name}» в порядке, ничего не сохранено. Остаток ${this.fmtH(r.remaining)} не меньше 10 — ISS не примет его одной записью (переполнение). ` + (plan.error ? plan.error : `Будет внесено частей: ${plan.entries.length} (${plan.entries.map(e => this.fmtH(e.cents / 100)).join(' + ')}), по одной на даты: ${plan.entries.map(e => this.isoToRu(e.date)).join(', ')}.`) }
          } else if (r.checked) {
            na.check = { ok: true, text: `Форма «${w.name}» в порядке, ничего не сохранено. Остаток ${this.fmtH(r.remaining)} будет внесён одной записью на ${this.isoToRu(na.from)}.` }
          } else {
            na.check = { ok: false, text: `Проверка формы «${w.name}» не прошла: ${message || 'ISS не вернул подробностей'}` }
          }
          return
        }
        if (r.added) { added++; hours += r.entry ? r.entry.hours : 0; label = 'внесено'; ok = true } else if (r.needsSplit) {
          // ошибка базы ISS: 4+ цифры не вносятся — делим остаток и вносим по частям на разные даты
          const plan = nonAudit.plan(r.remaining, na.from, na.to)
          if (plan.error) { label = 'не внесено'; message = plan.error } else {
            let done = 0
            let left = r.remaining       // остаток, который сейчас вписывает «Закрыть»: после каждой внесённой части он уменьшается
            for (const part of plan.entries) {
              if (na.cancel) break
              na.progress = `внесение: ${i + 1} из ${list.length} · ${w.name} · часть ${done + 1} из ${plan.entries.length}`
              r = await this.naPost(w, part.date, nonAudit.fromCents(part.cents), false, Math.round(left * 100) / 100)
              if (!r.added) { message = `Часть ${done + 1} из ${plan.entries.length}: ${r.error || 'ISS не внёс запись'}`; break }
              done++; added++; hours += part.cents / 100; left -= part.cents / 100
            }
            ok = done === plan.entries.length
            label = ok ? `внесено частями: ${done}` : (done ? `внесено ${done} из ${plan.entries.length}` : 'не внесено')
          }
        } else { label = 'не внесено'; message = r.error || 'ISS не внёс запись.' }
        if (!ok) failed++
        this.$set(na.results, w.id, { ok, label, message })
        if (ok) this.$delete(na.checked, w.id)
      }
      na.running = false
      na.progress = ''
      na.done = true
      na.summary = `Внесено записей: ${added} (${this.fmtH(hours)} ч)${failed ? `; не внесено работ: ${failed} (причины — у каждой работы)` : ''}${na.cancel ? '; остановлено' : ''}. Чтобы цифры в таблице обновились, нажмите «Обновить из ISS».`
    },
    // --- перенос отмеченных записей ---
    markKey(x) { return `${x.work.id}|${x.entry.id}` },
    canMark(x) {
      return !!x.work && !x.entry.approved && !this.deletedIds[x.entry.id] && !this.movedIds[x.entry.id] && !this.tr.running
    },
    toggleMark(x, it, on) {
      const k = this.markKey(x)
      if (on) this.$set(this.marks, k, { work: x.work.id, workName: x.work.name, id: String(x.entry.id), day: it.day, hours: x.entry.hours, label: x.label })
      else this.$delete(this.marks, k)
    },
    clearMarks() { this.marks = {} },
    openTransfer() {
      const list = this.markedList
      if (!list.length) return
      const days = list.map(m => m.day).sort()
      const max = days[days.length - 1] > this.today ? days[days.length - 1] : this.today
      const plus = new Date(Date.parse(max + 'T00:00:00Z') + 14 * 86400000).toISOString().slice(0, 10)
      this.tr = { ...this.tr, from: days[0], to: plus, planning: false, running: false, cancel: false, progress: '', error: '', plan: null, checked: {}, results: {}, done: false, summary: '', jobId: '' }
      this.$bvModal.show('loadtransferwin')
    },
    onTransferHide(e) {
      if (this.tr.planning || this.tr.running) e.preventDefault()
    },
    pairTimeOf(p) { return PAIR_STARTS[p - 1] || '' },
    trItemLabel(it) { return `${this.shortDate(it.day)} ${it.time || ''} ${it.workName || it.predm || ''}`.trim() },
    authBody() { return { login: this.login, passwordAES: this.passwordAES } },
    async makePlan() {
      const t = this.tr
      t.error = ''; t.check = null; t.plan = null; t.results = {}; t.done = false; t.checked = {}
      if (!t.from || !t.to || t.from > t.to) { t.error = 'Укажите окно дат: «с» не позже «по».'; return }
      t.planning = true; t.progress = 'запускаю…'
      try {
        const { data } = await this.axios.post(PATH + '/api/iss/transfer/plan/start', {
          ...this.authBody(), works: this.auditWorks, marked: this.markedList.map(m => ({ work: m.work, id: m.id })),
          window: { from: t.from, to: t.to }, options: { maxPerDay: Math.max(1, Math.min(7, Number(t.maxPerDay) || 4)) }, useChat: t.useChat, today: this.today,
        }, { timeout: 60000 })
        t.jobId = data.jobId
        this.pollPlan()
      } catch (e) {
        t.planning = false
        t.error = (e.response && e.response.data && e.response.data.error) || 'Не удалось запустить построение плана.'
      }
    },
    async pollPlan() {
      const t = this.tr
      try {
        const { data } = await this.axios.post(PATH + '/api/iss/transfer/plan/status', { ...this.authBody(), jobId: t.jobId }, { timeout: 30000 })
        if (data.status === 'running') {
          const p = data.progress || {}
          t.progress = p.total ? `расписание групп из чата: ${p.done} из ${p.total}${p.group ? ' · ' + p.group : ''}` : 'подбираю пары…'
          this.planTimer = setTimeout(() => this.pollPlan(), 1000)
          return
        }
        t.planning = false
        if (data.status === 'done' && data.plan) {
          if (data.plan.error) t.error = data.plan.error
          else {
            data.plan.placements.forEach(p => { p.manual = false; p.auto = { toDay: p.toDay, toPair: p.toPair, kab: p.kab } })
            t.plan = data.plan; t.editKey = ''
            data.plan.placements.forEach(p => this.$set(t.checked, p.key, true))
          }
        } else t.error = data.error || 'План не получен.'
      } catch (e) {
        this.planTimer = setTimeout(() => this.pollPlan(), 2000)
      }
    },
    async cancelPlan() {
      try { await this.axios.post(PATH + '/api/iss/transfer/plan/cancel', { ...this.authBody(), jobId: this.tr.jobId }) } catch (e) { /* остановится само */ }
      this.tr.progress = 'останавливаю…'
    },
    // --- ручная правка места ---
    toggleEdit(p) { this.tr.editKey = this.tr.editKey === p.key ? '' : p.key },
    gridDays(p) { return Object.keys(p.grid || {}).sort() },
    // код места (дата + пара) для записи p: карта занятости с сервера + пересечение с другими переносами этого плана
    slotCode(p, day, pair) {
      const row = p.grid && p.grid[day]
      let code = row ? row[pair - 1] : '?'
      if (code === '0' || code === '?') {
        const n = Math.max(1, p.pairs || 1)
        const clash = this.tr.plan.placements.some(q => q !== p && this.tr.checked[q.key] && !this.tr.results[q.key] && q.toDay === day && q.toPair < pair + n && pair < q.toPair + Math.max(1, q.pairs || 1))
        if (clash) code = '4'
      }
      return code
    },
    freeCount(p, day) { let c = 0; for (let n = 1; n <= 7; n++) if (this.slotCode(p, day, n) === '0') c++; return c },
    touch(p) { p.manual = p.toDay !== p.auto.toDay || p.toPair !== p.auto.toPair || p.kab !== p.auto.kab },
    setDay(p, day) { if (/^\d{4}-\d{2}-\d{2}$/.test(day)) { p.toDay = day; this.touch(p) } },
    setPair(p, n) { p.toPair = n; this.touch(p) },
    setKab(p, v) { p.kab = String(v || '').trim(); this.touch(p) },
    resetPlacement(p) { p.toDay = p.auto.toDay; p.toPair = p.auto.toPair; p.kab = p.auto.kab; this.touch(p) },
    async confirmMoves() {
      const n = this.checkedPlacements.length
      const risky = this.checkedPlacements.filter(p => this.slotCode(p, p.toDay, p.toPair) !== '0').length
      const manual = this.checkedPlacements.filter(p => p.manual).length
      const ok = await this.$bvModal.msgBoxConfirm(
        `В журнале ISS у ${n} ${this.plural(n, 'записи', 'записей', 'записей')} будет изменена дата и пара${manual ? ` (выбрано вручную: ${manual})` : ''}.${risky ? ` Внимание: ${risky} из них — на занятом или неизвестном месте.` : ''} Каждая запись проверяется по журналу после сохранения. Перенесённую запись можно вернуть на прежнее место вручную в ISS, пока она не утверждена.`,
        { title: 'Перенести записи в ISS?', okTitle: 'Перенести', okVariant: 'danger', cancelTitle: 'Отмена', centered: true, size: 'sm' })
      if (ok) this.runMoves(false)
    },
    // check: заполнить форму для первой записи и закрыть без сохранения
    async runMoves(check) {
      const t = this.tr
      const list = check ? this.checkedPlacements.slice(0, 1) : this.checkedPlacements
      if (!list.length) return
      t.running = true; t.cancel = false; t.error = ''; t.check = null; t.done = false
      const auth = { login: this.login, passwordAES: this.passwordAES, semester: this.semester }
      let moved = 0, failed = 0
      for (let i = 0; i < list.length; i++) {
        if (t.cancel) break
        const p = list[i]
        t.progress = `${check ? 'проверка формы' : 'перенос'}: ${i + 1} из ${list.length} · ${p.workName}`
        let res
        try {
          const { data } = await this.axios.post(PATH + '/api/iss/worklist/move', {
            auth, data: { id: p.work, entryId: Number(p.move.id), date: this.isoToRu(p.from.day), name: p.workName, to: { date: this.isoToRu(p.toDay), pair: p.toPair, hours: p.hours, kab: p.kab || '' }, check: !!check },
          }, { timeout: 120000 })
          if (check) res = data.checked ? { ok: true, label: 'форма в порядке', message: 'Форма заполняется, ничего не сохранено.' } : { ok: false, label: 'ошибка', message: data.error || 'Форма не заполнилась.' }
          else res = data.moved ? { ok: true, label: 'перенесено', message: '' } : { ok: false, label: 'не перенесено', message: data.error || 'ISS не изменил запись.' }
        } catch (e) {
          res = { ok: false, label: 'ошибка', message: (e.response && e.response.data && e.response.data.error) || (e.code === 'ECONNABORTED' ? 'ISS не ответил за 120 с — проверьте журнал работы в ISS.' : 'Сервер не ответил.') }
        }
        this.$set(t.results, p.key, res)
        if (check) { if (!res.ok) failed++; t.check = { ok: res.ok, text: res.ok ? 'Форма записи в ISS заполняется правильно: дата, часы и пара выбираются, запись не сохранялась.' : `Проверка формы не прошла: ${res.message}` }; break }
        if (res.ok) { moved++; this.$set(this.movedIds, p.move.id, true); this.$delete(this.marks, `${p.work}|${p.move.id}`); this.clearLocalIssMove(p) } else failed++
      }
      t.running = false
      if (check) {
        const r = t.results[list[0].key]
        t.error = r.ok ? '' : `Проверка формы не прошла: ${r.message}`
        // результат проверки остаётся в окне, пока его не закроют (всплывающее сообщение исчезало слишком быстро)
        t.check = r.ok ? { ok: true, text: 'Форма записи в ISS заполняется правильно: дата, часы и пара выбираются, запись не сохранялась.' } : null
        this.$delete(t.results, list[0].key)
        return
      }
      t.done = true
      t.summary = `Перенесено записей: ${moved}${failed ? `; не перенесено: ${failed} (причины — у каждой записи)` : ''}${t.cancel ? '; остановлено' : ''}. Чтобы отчёт учёл изменения, повторите аудит.`
    },
    clearLocalIssMove(p) {
      const day = p.from.day
      const d = this.days.find(x => x.day === day)
      if (!d) return
      const pairs = Array.from({ length: p.move.hours ? Math.max(1, Math.ceil(p.move.hours / 2)) : 1 }, (_, i) => p.from.pair + i)
      d.lessons.forEach(l => { if (l.predm === p.workName && pairs.includes(PAIR(l.time))) l.in_iss = 0 })
    },
    rerunAudit() {
      this.$bvModal.hide('loadtransferwin')
      const scope = this.audit.scope
      this.$nextTick(() => this.runAudit(scope))
    },
    exportAudit() {
      const rows = [['Проверка', 'Дата', 'Время', 'Работа / занятие', 'Описание']]
      TILES.forEach(t => this.scoped[t.k].forEach(it => {
        rows.push([t.title, it.day ? it.day.split('-').reverse().join('.') : '', it.time || '', this.itemTitle(t.k, it), this.itemText(t.k, it)])
      }))
      const ws = utils.aoa_to_sheet(rows)
      ws['!cols'] = [{ wch: 24 }, { wch: 12 }, { wch: 12 }, { wch: 50 }, { wch: 70 }]
      const wb = utils.book_new()
      utils.book_append_sheet(wb, ws, 'Аудит')
      writeFile(wb, `Аудит_нагрузки_${this.today}.xlsx`)
    },
  },
}
</script>

<style>
/* окно — во весь экран (на компьютере и на телефоне) */
.ld-dialog {
  margin: 0;
  max-width: none;
  width: 100vw;
  height: 100%;
}
.ld-dialog .modal-content {
  height: 100vh;
  height: 100dvh;
  border: 0;
  border-radius: 0;
}
.ld-dialog .ld-body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
}
.ld-dialog .modal-header { align-items: center; padding: 10px 16px; }
@media (max-width: 575.98px) {
  .ld-audit-dialog { margin: 0; max-width: 100%; }
  .ld-audit-dialog .modal-content { min-height: 100vh; min-height: 100dvh; border-radius: 0; }
}
</style>

<style scoped>
.ld-title { font-weight: 600; }
.ld-menu {
  flex: none;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 8px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-elevated);
  overflow-x: auto;
  scrollbar-width: none;
}
.ld-menu-flat { border-top: 1px solid var(--border); }
.ld-mi {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 34px;
  padding: 0 10px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--text);
  font: inherit;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
}
.ld-mi svg { color: var(--text-muted); font-size: 16px; }
.ld-mi:hover:not(:disabled) { background: var(--item-hover); }
.ld-mi:focus-visible { outline: 2px solid var(--primary); outline-offset: -2px; }
.ld-mi:disabled { opacity: .45; cursor: default; }
.ld-mi[aria-pressed="true"] { background: var(--item-hover); color: var(--primary); }
.ld-mi[aria-pressed="true"] svg { color: var(--primary); }
.ld-mi-primary { color: var(--primary); font-weight: 600; }
.ld-mi-primary svg { color: var(--primary); }
.ld-seg { display: inline-flex; border: 1px solid var(--border); border-radius: 6px; padding: 1px; margin-left: 4px; }
.ld-seg .ld-mi { min-height: 30px; }
.ld-sep { flex: none; width: 1px; height: 20px; margin: 0 4px; background: var(--border); }
.ld-meta { margin-left: auto; font-size: 12px; color: var(--text-muted); white-space: nowrap; padding: 0 4px; }

.ld-kpis { flex: none; display: flex; flex-wrap: wrap; background: var(--bg-elevated); border-bottom: 1px solid var(--border); }
.ld-kpi { padding: 8px 16px; border-right: 1px solid var(--border); min-width: 0; }
.ld-kpi b { display: block; font-size: 20px; font-weight: 700; line-height: 1.15; font-variant-numeric: tabular-nums; }
.ld-kpi span { font-size: 12px; color: var(--text-muted); }
.ld-kpi.ld-bad b { color: var(--danger); }
.ld-kpi.ld-good b { color: var(--success); }
.ld-track { position: relative; width: 170px; max-width: 100%; height: 6px; background: var(--bg-muted); margin-top: 5px; }
.ld-track i { position: absolute; inset: 0 auto 0 0; background: var(--primary); }
.ld-track em { position: absolute; top: -3px; bottom: -3px; width: 2px; background: var(--text); opacity: .6; }

.ld-main { flex: 1; min-height: 0; overflow: auto; overscroll-behavior: contain; position: relative; background: var(--bg); }
.ld-empty { padding: 24px 16px; color: var(--text-muted); text-align: center; margin: 0; }
.ld-note { margin: 0; padding: 8px 14px 14px; font-size: 12px; color: var(--text-muted); }
.ld-dim { color: var(--text-muted); }

/* полоса: факт + засечка «ожидаемо к сегодня» */
.ld-bar { position: relative; display: block; height: 8px; min-width: 60px; background: var(--bg-muted); }
.ld-bar i { position: absolute; inset: 0 auto 0 0; }
.ld-bar em { position: absolute; top: -3px; bottom: -3px; width: 2px; background: var(--text); opacity: .5; }
.ld-c0 { background: #2563eb; } .ld-c1 { background: var(--primary); } .ld-c2 { background: #9333ea; } .ld-c3 { background: #64748b; }
.ld-t0 { color: #2563eb; } .ld-t1 { color: var(--primary); } .ld-t2 { color: #9333ea; } .ld-t3 { color: #64748b; }
@media (prefers-color-scheme: dark) {
  .ld-c0 { background: #60a5fa; } .ld-c2 { background: #c084fc; }
  .ld-t0 { color: #60a5fa; } .ld-t2 { color: #c084fc; }
}
.ld-num { font-variant-numeric: tabular-nums; font-size: 12px; white-space: nowrap; }
.ld-chip { display: inline-block; padding: 1px 8px; border-radius: 10px; font-size: 11px; font-weight: 600; white-space: nowrap; }
.ld-chip-ok { background: var(--color-free-bg); color: var(--success); }
.ld-chip-warn { background: var(--color-current-bg); color: var(--warning); }
.ld-chip-bad { background: var(--color-busy-bg); color: var(--danger); }

/* карточки */
.ld-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(290px, 1fr)); gap: 10px; padding: 12px; }
.ld-card {
  display: grid;
  gap: 8px;
  align-content: start;
  text-align: left;
  font: inherit;
  color: var(--text);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
}
.ld-card:hover { border-color: var(--primary); }
.ld-card:focus-visible { outline: 2px solid var(--primary); outline-offset: 1px; }
.ld-card-top { display: flex; justify-content: space-between; gap: 8px; align-items: flex-start; }
.ld-card-title b { display: block; font-size: 14px; font-weight: 600; line-height: 1.3; }
.ld-card-title small { font-size: 12px; color: var(--text-muted); }
.ld-ring { flex: none; width: 52px !important; height: 52px !important; color: var(--text); }
.ld-wrow { display: grid; grid-template-columns: 62px minmax(0, 1fr) 58px; gap: 8px; align-items: center; }
.ld-lbl { font-size: 12px; font-weight: 600; line-height: 1.15; }
.ld-lbl small { display: block; font-size: 10px; font-weight: 400; color: var(--text-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ld-card-foot { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 4px; font-size: 12px; color: var(--text-muted); border-top: 1px solid var(--border); padding-top: 6px; }

/* сводная таблица */
.ld-tablewrap { min-width: 0; }
.ld-table { border-collapse: separate; border-spacing: 0; width: 100%; font-size: 13px; background: var(--bg-elevated); }
.ld-table th, .ld-table td { border-right: 1px solid var(--border); border-bottom: 1px solid var(--border); padding: 6px 8px; vertical-align: middle; text-align: left; }
.ld-table thead th { position: sticky; top: 0; z-index: 2; background: var(--bg-muted); font-weight: 600; white-space: nowrap; border-bottom: 2px solid #b8cdc8; }
.ld-table .ld-nm { position: sticky; left: 0; z-index: 1; background: var(--bg-elevated); min-width: 230px; border-right: 2px solid #b8cdc8; font-weight: 600; }
.ld-table thead .ld-nm { z-index: 3; background: var(--bg-muted); }
.ld-table .ld-nm small { display: block; font-weight: 400; font-size: 12px; color: var(--text-muted); }
.ld-table td small { display: block; color: var(--text-muted); margin-top: 3px; }
.ld-tot b { font-size: 14px; }
.ld-row { cursor: pointer; }
.ld-row:hover td, .ld-row:hover th, .ld-open td, .ld-open th { background: var(--item-hover); }
.ld-row:focus-visible { outline: 2px solid var(--primary); outline-offset: -2px; }
.ld-det td { background: var(--bg); padding: 8px 10px 10px; }
.ld-pill { display: inline-block; margin: 0 4px 4px 0; padding: 1px 6px; font-size: 12px; border: 1px solid var(--border); background: var(--bg-elevated); white-space: nowrap; }
.ld-pill-no { border-color: var(--danger); color: var(--danger); }
.ld-more { min-height: 28px; margin-left: 4px; }

/* окно предмета (выезжает справа) */
.ld-drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(560px, 100%);
  z-index: 10;
  display: flex;
  flex-direction: column;
  background: var(--bg-elevated);
  border-left: 1px solid #b8cdc8;
  box-shadow: -8px 0 24px var(--shadow);
  transform: translateX(105%);
  transition: transform .22s cubic-bezier(.2, .8, .2, 1);
  visibility: hidden;
}
.ld-drawer-on { transform: none; visibility: visible; }
.ld-dh { padding: 10px 14px; display: grid; gap: 6px; }
.ld-dh-row { display: flex; align-items: flex-start; gap: 8px; }
.ld-dh h6 { margin: 0; flex: 1; font-size: 16px; font-weight: 600; }
.ld-x { border: 0; background: none; color: var(--text-muted); font-size: 22px; line-height: 1; width: 32px; height: 32px; cursor: pointer; }
.ld-dsum { display: flex; flex-wrap: wrap; gap: 6px; }
.ld-dsum > span { font-size: 12px; padding: 2px 8px; border: 1px solid var(--border); border-radius: 10px; }
.ld-dlist { flex: 1; min-height: 0; overflow: auto; overscroll-behavior: contain; }
.ld-issact { display: inline-flex; align-items: center; gap: 4px; }
.ld-del {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--bg-elevated);
  color: var(--danger);
  cursor: pointer;
}
.ld-del:hover:not(:disabled) { background: var(--color-busy-bg); border-color: var(--danger); }
.ld-del:disabled { opacity: .5; cursor: default; }
.ld-warn-pad { padding: 4px 14px; margin: 0; }
.ld-synced { margin-top: 6px; font-size: 13px; color: var(--success); }
.ld-delerr { display: block; margin-top: 4px; font-size: 12px; color: var(--danger); font-weight: 600; }
.ld-delerr-row { grid-column: 1 / -1; margin-top: 0; }
.ld-aacts { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 5px; }
.ld-adel { display: inline-flex; align-items: center; gap: 4px; padding: 1px 8px; font-size: 12px; border-radius: 4px; }
.ld-month { position: sticky; top: 0; padding: 5px 14px; font-size: 11px; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; color: var(--text-muted); background: var(--bg-muted); }
.ld-lesson { display: grid; grid-template-columns: 76px 1fr auto; gap: 8px; align-items: center; padding: 7px 14px; border-bottom: 1px solid var(--border); font-size: 13px; }
.ld-lesson-no { background: var(--color-busy-bg); }
.ld-ld b { display: block; }
.ld-ld small, .ld-lw small { display: block; color: var(--text-muted); font-size: 12px; }

/* отчёт аудита */
.ld-audit-head { margin-bottom: 8px; }
.ld-audit-head .ld-dim { font-size: 13px; }
.ld-prog { position: relative; height: 6px; margin-top: 6px; background: var(--bg-muted); }
.ld-prog i { position: absolute; inset: 0 auto 0 0; background: var(--primary); transition: width .2s ease; }
.ld-warn { margin-top: 8px; font-size: 13px; color: var(--warning); }
.ld-tiles { display: grid; grid-template-columns: repeat(6, minmax(0, 1fr)); border: 1px solid var(--border); }
.ld-tile {
  padding: 8px 10px;
  text-align: left;
  font: inherit;
  color: var(--text);
  background: var(--bg-elevated);
  border: 0;
  border-right: 1px solid var(--border);
  border-bottom: 3px solid transparent;
  cursor: pointer;
}
.ld-tile:last-child { border-right: 0; }
.ld-tile b { display: block; font-size: 20px; font-variant-numeric: tabular-nums; }
.ld-tile small { display: block; font-size: 11px; line-height: 1.2; color: var(--text-muted); }
.ld-tile-on { border-bottom-color: var(--primary); background: var(--item-hover); }
.ld-tile-bad b { color: var(--danger); } .ld-tile-warn b { color: var(--warning); } .ld-tile-zero b { color: var(--success); }
.ld-alist { max-height: 50vh; overflow: auto; overscroll-behavior: contain; border: 1px solid var(--border); border-top: 0; }
.ld-hint { margin: 0; padding: 8px 12px; font-size: 12px; color: var(--text-muted); background: var(--bg-muted); }
.ld-aitem { display: grid; grid-template-columns: 90px 1fr; gap: 8px; padding: 7px 12px; border-bottom: 1px solid var(--border); font-size: 13px; }
.ld-aitem small { display: block; color: var(--text-muted); }
.ld-af { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-top: 10px; font-size: 12px; flex-wrap: wrap; }
.ld-afb { display: flex; gap: 6px; flex-wrap: wrap; }
.ld-aentry { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 6px; margin-right: 10px; }
.ld-mark { display: inline-flex; align-items: center; gap: 4px; margin: 0; font-size: 12px; cursor: pointer; }
.ld-trform { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; }
.ld-trform label { margin: 0; font-size: 12px; color: var(--text-muted); }
.ld-trchk { display: flex; align-items: center; gap: 6px; margin: 8px 0 0; font-size: 13px; }
.ld-trbar { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin-top: 10px; }
.ld-trnote { margin: 8px 0 0; font-size: 12px; color: var(--text-muted); }
.ld-trun { margin-top: 8px; padding: 8px 10px; font-size: 12px; border: 1px solid var(--border); background: var(--bg-muted); }
.ld-trlist { margin-top: 8px; max-height: 40vh; overflow: auto; border: 1px solid var(--border); }
.ld-tritem { display: grid; grid-template-columns: auto 190px 1fr auto; align-items: center; gap: 8px; margin: 0; padding: 6px 10px; border-bottom: 1px solid var(--border); font-size: 13px; cursor: pointer; }
.ld-tritem-done { opacity: .7; }
.ld-trrow { border-bottom: 1px solid var(--border); }
.ld-trrow .ld-tritem { border-bottom: 0; }
.ld-tredit { padding: 6px 10px 10px 34px; background: var(--bg-muted); }
.ld-trdays { display: flex; gap: 4px; overflow-x: auto; padding-bottom: 6px; }
.ld-trday { flex: none; min-width: 58px; padding: 3px 6px; font: inherit; font-size: 12px; color: var(--text-muted); background: var(--bg-elevated); border: 1px solid var(--border); cursor: pointer; }
.ld-trday small { display: block; font-size: 10px; }
.ld-trday.free { color: var(--success); border-color: var(--success); }
.ld-trday.on { color: #fff; background: var(--primary); border-color: var(--primary); }
.ld-trform2 { grid-template-columns: repeat(2, minmax(0, 1fr)); margin-top: 6px; }
.ld-trpairs { display: grid; grid-template-columns: repeat(7, minmax(0, 1fr)); gap: 4px; margin-top: 8px; }
.ld-trpair { padding: 4px 2px; font: inherit; font-size: 12px; line-height: 1.2; color: var(--text); background: var(--bg-elevated); border: 2px solid var(--border); cursor: pointer; }
.ld-trpair small { display: block; font-size: 10px; color: var(--text-muted); }
.ld-trpair.on { border-color: var(--primary); box-shadow: inset 0 0 0 1px var(--primary); }
.ld-slot-0 { background: color-mix(in srgb, var(--success) 18%, var(--bg-elevated)); }
.ld-slot-1, .ld-slot-2, .ld-slot-4 { background: color-mix(in srgb, var(--danger) 18%, var(--bg-elevated)); }
.ld-slot-3 { background: color-mix(in srgb, var(--warning) 22%, var(--bg-elevated)); }
.ld-slot-9, .ld-slot-\? { opacity: .6; }
.ld-trwarn { margin: 8px 0 0; font-size: 12px; color: var(--danger); }
.ld-nabar { position: sticky; bottom: -1rem; z-index: 3; margin: 12px -1rem -1rem; padding: 10px 1rem; background: var(--bg-elevated); border-top: 1px solid var(--border); box-shadow: 0 -4px 10px rgba(0, 0, 0, .08); }
.ld-nabar .ld-trbar { margin-top: 0; }
.ld-nasum { font-weight: 600; font-size: 13px; }
.ld-nasec { margin-top: 10px; border: 1px solid var(--border); }
.ld-nahead { display: flex; align-items: center; gap: 8px; margin: 0; padding: 4px 10px; background: var(--bg-muted); border-bottom: 1px solid var(--border); }
.ld-nahl { display: flex; align-items: center; gap: 8px; margin: 0; cursor: pointer; }
.ld-fold { padding: 2px 4px; line-height: 1; color: var(--text); background: none; border: 0; cursor: pointer; }
.ld-nafilter { display: flex; align-items: flex-end; flex-wrap: wrap; gap: 8px 16px; margin-top: 8px; }
.ld-nafl { display: flex; flex-direction: column; gap: 2px; margin: 0; font-size: 12px; color: var(--text-muted); }
.ld-nafold { display: flex; gap: 12px; margin-left: auto; }
.ld-linkbtn { padding: 0; font-size: 12px; color: var(--primary); background: none; border: 0; text-decoration: underline; cursor: pointer; }
.ld-nahead .ld-dim { margin-left: auto; font-size: 12px; }
.ld-nawork { display: grid; grid-template-columns: auto 1fr auto auto auto; align-items: center; gap: 8px; margin: 0; padding: 5px 10px; border-bottom: 1px solid var(--border); font-size: 13px; cursor: pointer; }
.ld-nawork:last-child { border-bottom: 0; }
.ld-nawork-off { opacity: .6; cursor: default; }
.ld-nawhat small { display: block; color: var(--text-muted); }
.ld-nanum { font-variant-numeric: tabular-nums; color: var(--text-muted); white-space: nowrap; }
@media (max-width: 575.98px) {
  .ld-nawork { grid-template-columns: auto 1fr; }
  .ld-nawork .ld-nanum, .ld-nawork .ld-chip { grid-column: 2; justify-self: start; }
}
.ld-trwhen i { font-style: normal; color: var(--text-muted); }
.ld-trwhat small { display: block; color: var(--text-muted); }
@media (max-width: 575.98px) {
  .ld-trform { grid-template-columns: 1fr; }
  .ld-tritem { grid-template-columns: auto 1fr; }
  .ld-tredit { padding-left: 10px; }
  .ld-trpairs { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .ld-tritem .ld-trwhat { grid-column: 2; }
}

@media (max-width: 767.98px) {
  .ld-long, .ld-hide-m, .ld-meta { display: none; }
  .ld-kpi { flex: 1 1 50%; padding: 6px 12px; }
  .ld-kpi b { font-size: 17px; }
  .ld-track { width: 100%; }
  .ld-cards { grid-template-columns: 1fr; padding: 8px; }
  .ld-table .ld-nm { min-width: 150px; }
  .ld-tiles { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .ld-lesson { grid-template-columns: 64px 1fr auto; padding: 7px 10px; }
}
@media (prefers-reduced-motion: reduce) {
  .ld-drawer, .ld-prog i { transition: none; }
}
</style>
